import { defaultColumns, defaultSort } from '../../components/reports/productConsumption/columns';

export default {
  state: {
    productConsumption: [],
    loading: false,
    tableConfig: null,
    filterString: null,
    sorting: {
      prop: 'gross_price',
      order: 'desc',
    },
  },
  getters: {
    productConsumption: state => state.productConsumption,
    loading: state => state.loading,
    tableConfig: state => state.tableConfig,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
  },
  mutations: {
    setProductConsumption(state, productConsumption) {
      state.productConsumption = productConsumption;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/product-consumption-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'product-consumption-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const productConsumption = await axios.get('api/reports/product-consumption' + (query || ''));
        commit('setProductConsumption', productConsumption);
      } catch (e) {
      }
      commit('setLoading', false);
    },
  },
};
